export default "__VITE_ASSET__942690ec__"